import { logService, LOG_CATEGORIES } from '@/services/logService'

import type { Router } from 'vue-router'

const DEEP_LINK_HOST = 'route.camp'

function normalizeDeepLinkPath(url: string): string | null {
  try {
    const parsed = new URL(url)
    if (parsed.protocol !== 'https:') return null
    if (parsed.hostname !== DEEP_LINK_HOST) return null

    const path = parsed.pathname || '/'
    const search = parsed.search || ''
    const hash = parsed.hash || ''
    return `${path}${search}${hash}`
  } catch {
    return null
  }
}

export async function handleRoutecampDeepLinks(router: Router, urls: string[]): Promise<boolean> {
  logService.info(LOG_CATEGORIES.GENERAL, 'Received deep link URLs', { count: urls.length })

  for (const url of urls) {
    const targetPath = normalizeDeepLinkPath(url)
    if (!targetPath) continue

    try {
      if (router.currentRoute.value.fullPath !== targetPath) {
        await router.push(targetPath)
      }
      logService.info(LOG_CATEGORIES.GENERAL, 'Deep link navigation complete', {
        routeName: router.currentRoute.value.name,
      })
      return true
    } catch (error) {
      logService.error(LOG_CATEGORIES.GENERAL, 'Failed to navigate deep link', {
        error,
      })
    }
  }

  return false
}
